module.exports = __webpack_public_path__ + "static/media/bootstrap_logo.633f58bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tech_logos/bootstrap_logo.png
// module id = 82
// module chunks = 0